import { ConsiderationTypeHoldingClassTypes } from 'further-types/lp/realisation';
import { CurrencyCode } from 'further-types/lp/vehicle';

type GetRealisationTypeInput = {
  holdingClassInvestment: {
    currency: CurrencyCode;
  };
  vehicleCurrencyCode: CurrencyCode;
  realisationCurrencyCode: CurrencyCode;
};

const getRealisationType = ({
  holdingClassInvestment,
  vehicleCurrencyCode,
  realisationCurrencyCode,
}: GetRealisationTypeInput) => {
  const holdingClassCurrency = holdingClassInvestment.currency;

  // Determine currency relationships
  const isHoldingClassInLcy = holdingClassCurrency === vehicleCurrencyCode;
  const isRealisationInLcy = realisationCurrencyCode === vehicleCurrencyCode;
  const isHoldingClassSameAsRealisation =
    holdingClassCurrency === realisationCurrencyCode;

  // Case 1: Holding class is in local currency (LCY)
  if (isHoldingClassInLcy) {
    return ConsiderationTypeHoldingClassTypes.LcyHoldingClass;
  }

  // Case 2: Non-LCY holding class with LCY realisation
  if (isRealisationInLcy) {
    return ConsiderationTypeHoldingClassTypes.LcyConsiderationForNonLcyHoldingClass;
  }

  // Case 3: All three currencies are different (holding class ≠ vehicle ≠ realisation)
  if (!isHoldingClassSameAsRealisation) {
    return ConsiderationTypeHoldingClassTypes.ThreeCYNonLcyConsiderationNonLcyHoldingClass;
  }

  // Case 4: Non-LCY holding class with same non-LCY realisation currency
  return ConsiderationTypeHoldingClassTypes.NonLcyConsiderationNonLcyHoldingClass;
};

export default getRealisationType;
